<template>
  <div class="article" :style="{top: top}" @animationend="articleClosed" ref="article">
    <div class="article-placeholder" :style="{height: height}">
      <div class="background">
        <img v-if="!!article.Image" :src="`https://wagner-hatfield.com/administration/upload/article/${article.Image}`"
             alt="background"/>
      </div>
      <p class="title-header">{{article.ShortDescription}}</p>
      <p class="title">{{article.Title}}</p>
      <a class="read-more" v-html="$translations.get('read_more')">Read case study</a>
      <div class="article-close" @click="closeArticle">
        <img src="./../assets/images/close.svg" alt="close"/>
      </div>
    </div>
    <div class="article-body">
      <p class="title-header">{{article.ShortDescription}}<span v-if="showDate" class="date"> - {{formattedDate}}</span>
      </p>
      <p class="title">{{article.Title}}</p>
      <div class="text" v-html="article.Description">
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "ExpandableArticle",
    metaInfo() {
      const title = this.article.Title;
      const description = this.article.ShortDescription;
      const image = this.article.Image;
      return {
        title: title,
        meta: [
          { charset: 'utf-8' },
          {
            property: 'og:title',
            content: title,
            template: slug => `${slug} - Wagner-Hatfield`,
            vmid: 'og:title'
          },
          {
            property: 'og:description',
            content: description,
            vmid: 'og:description'
          },
          {
            property: 'og:image',
            content: image,
            template: 'https://wagner-hatfield.com/administration/upload/article/%s',
            vmid: 'og:image'
          },
          {
            name: 'twitter:card',
            content: image,
            template: 'https://wagner-hatfield.com/administration/upload/article/%s',
            vmid: 'twitter:card'
          },
          {
            property: 'og:url',
            content: window.location.href,
            vmid: 'og:url'
          }
        ]
      }
    },
    props: {
      article: {
        type: Object,
        required: false
      },
      top: {
        type: String,
        required: false
      },
      height: {
        type: String,
        required: false
      },
      showDate: {
        type: Boolean,
        required: false
      }
    },
    data: () => ({
      articleExpanded: false
    }),
    computed: {
      formattedDate: function () {
        if (this.article) {
          let date = this.article.CreateDate;
          if (date) {
            let splits = date.split(" ");
            let dateSplits = splits[0].split("-");
            let timeSplits = splits[1].split(":");
            return `${dateSplits[2]}.${dateSplits[1]}.${dateSplits[0]} ${timeSplits[0]}:${timeSplits[1]}`;
          }
        }
        return "";
      }
    },
    methods: {
      closeArticle: function () {
        this.$el.classList.add("closed");
        this.$el.classList.remove("expanded");
        this.$refs["article"].parentElement.scrollTop = 0;
      },
      articleClosed: function (event) {
        if (event.target.classList.contains("closed")) {
          this.$router.push({name: this.$route.name});
          this.$emit("closed");
        }
      }
    },
    mounted: function () {
      console.log(this);
      setTimeout(() => {
        this.$el.classList.add("expanded");
      }, 100);
    }
  }
</script>

<style lang="scss" scoped>
  @import '../static/css/style';

  .article {
    position: absolute;
    min-height: 100vh;
    width: 100%;
    display: flex;
    flex-direction: column;
    @include transition(top $default-ease 500ms 500ms, opacity $default-ease 500ms 500ms);

    .article-placeholder {
      position: relative;
      display: block;
      padding: 2rem 4rem;
      cursor: pointer;
      background: rgba(0, 0, 0, 0.7);
      box-sizing: border-box;
      @include transition(height $default-ease 500ms 500ms);

      .background {
        position: absolute;
        top: 0;
        left: 0;
        height: 100%;
        width: 100%;
        background: #000;

        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }

      .title-header {
        position: relative;
        text-transform: uppercase;
        font-size: 0.7rem;
        font-family: 'OpenSans-Bold', sans-serif;
        color: #fff;
        margin: 0;
        z-index: 3;
        @include transition(opacity $default-ease 500ms 500ms);
      }

      .title {
        position: relative;
        font-size: 2.5rem;
        color: #fff;
        margin: 0.6vw 0;
        font-family: 'OpenSans-Bold', sans-serif;
        z-index: 3;
        @include transition(opacity $default-ease 500ms 500ms);
      }

      .read-more {
        position: relative;
        text-transform: uppercase;
        font-size: 0.7rem;
        font-family: 'OpenSans-Bold', sans-serif;
        color: $accent-color;
        margin: 0;
        opacity: 0.2;
        padding: 0.3em;
        z-index: 3;
        @include transition(opacity $default-ease 500ms 500ms);

        &::after {
          content: '';
          display: block;
          position: absolute;
          left: 50%;
          bottom: 0;
          width: 0;
          height: 2px;
          background: $accent-color;
          @include transition(width $default-ease 500ms, left $default-ease 500ms);
        }
      }

      .article-close {
        position: absolute;
        bottom: 0;
        left: 50%;
        width: 3rem;
        height: 3rem;
        margin-bottom: -1.5rem;
        margin-left: -1.5rem;
        z-index: 5;
        cursor: pointer;
        opacity: 0;
        @include transform(rotateZ(90deg));
        @include transition(opacity $default-ease 500ms, transform $default-ease 500ms);

        img {
          width: 100%;
          height: 100%;
          object-fit: contain;
        }
      }
    }

    .article-body {
      position: relative;
      background: #1F1F1F;
      overflow: hidden;
      flex: 1;
      transform-origin: center top;
      @include transform(scaleY(0));
      @include transition(transform $default-ease 500ms 500ms);

      .title-header {
        margin: 2rem 4rem 0 4rem;
        position: relative;
        text-transform: uppercase;
        font-size: 0.7rem;
        opacity: 0;
        font-family: 'OpenSans-Bold', sans-serif;
        color: rgba(255, 255, 255, 0.3);
        @include transition(opacity $default-ease 500ms);

        .date {
          color: #fff;
        }
      }

      .title {
        position: relative;
        font-size: 2.5rem;
        color: $accent-color;
        margin: 1rem 4rem;
        font-family: 'OpenSans-Bold', sans-serif;
        opacity: 0;
        @include transition(opacity $default-ease 500ms);
      }

      .text {
        position: relative;
        font-family: 'NeueHaasUnicaPro-Regular', sans-serif;
        font-size: 1rem;
        color: #fff;
        margin: 0 4rem 2rem 4rem;
        opacity: 0;
        @include transition(opacity $default-ease 500ms);

        a {
          color: red !important;
        }
      }
    }

    @include media-query(medium) {

      .article-placeholder {
        padding: 1rem 3rem;

        .title {
          font-size: 1.5rem;
        }
      }

      .article-body {

        .title-header {
          margin: 1rem 2rem 0 2rem;
        }

        .title {
          font-size: 1.5rem;
          margin: 1rem 2rem;
        }

        .text {
          font-size: 0.9rem;
          margin: 0 2rem 1rem 2rem;
        }
      }
    }


    &.expanded {
      top: 0 !important;
      @include transition(top $default-ease 500ms, opacity $default-ease 500ms);

      .article-placeholder {
        height: 55vh !important;
        @include transition(height $default-ease 500ms);

        .title-header {
          opacity: 0;
          @include transition(height $default-ease 500ms);
        }

        .title {
          opacity: 0;
          @include transition(opacity $default-ease 500ms);
        }

        .read-more {
          opacity: 0;
          @include transition(opacity $default-ease 500ms);
        }
      }

      .article-close {
        @include transition(opacity $default-ease 500ms 500ms, transform $default-ease 500ms 500ms);
        @include transform(rotateZ(0deg));
        opacity: 1;
      }

      .article-body {
        @include transform(scaleY(1));
        @include transition(transform $default-ease 500ms);

        .title-header {
          opacity: 1;
          @include transition(opacity $default-ease 500ms 500ms);
        }

        .title {
          opacity: 1;
          @include transition(opacity $default-ease 500ms 500ms);
        }

        .text {
          opacity: 1;
          @include transition(opacity $default-ease 500ms 500ms);
        }
      }
    }

    &.closed {
      max-height: 100%;
      @include animation(fadeOut 500ms $default-ease 1s 1 forwards);
    }
  }
</style>
